module.exports = __webpack_public_path__ + "static/media/robot-dashboard.3666a6e0.svg";